<template>
  <div>
    <p class="programs__error-text">
      <slot></slot>
    </p>
  </div>
</template>

<style scoped>
.programs__error-text {
  text-align: center;
  color: #ff0000;
}
</style>
